export type ILanguages = {
  es: string
  en: string
  it: string
  au: string
  us: string
  nl: string
  uk: string
  fr: string
  de?: string
  pages?: {}[]
}

export enum IRoutes {
  CALCULATOR = 'CALCULATOR',
  HOME = 'HOME',
  ABOUT_US = 'ABOUT_US',
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  CONTACT = 'CONTACT',
  GLOSSARY = 'GLOSSARY',
  TUTORIALS = 'TUTORIALS',
  JOBS = 'JOBS',
  FAQ = 'FAQ',
  MATERIALS = 'MATERIALS',
  EXPRESS_PRODUCTION = 'EXPRESS_PRODUCTION',
  DELIVERY_SHIPPING = 'DELIVERY_SHIPPING',
  FINISHING_TOUCHES = 'FINISHING_TOUCHES',
  REFERENCE_CUSTOMERS = 'REFERENCE_CUSTOMERS',
  CUSTOMERS_STORIES = 'CUSTOMERS_STORIES',
  NEWS = 'NEWS',
  PRESS = 'PRESS',
  LABEL_GALLERY = 'LABEL_GALLERY',
  CATEGORIES = 'CATEGORIES',
  PRODUCTS = 'PRODUCTS',
  PROOFING_SERVICE = 'PROOFING_SERVICE',
  ARTWORK_SERVICES = 'ARTWORK_SERVICES',
  PRINT_DATA_DELIVERY = 'PRINT_DATA_DELIVERY',
  SAMPLE_BOOK = 'SAMPLE_BOOK',
  ARTWORK_ASSISTANT = 'ARTWORK_ASSISTANT',
  DESIGN_SERVICE = 'DESIGN_SERVICE',
  SIGNUP_SUCCESS = 'SIGNUP_SUCCESS',
  TRANSPARENCY_CALCULATOR = 'TRANSPARENCY_CALCULATOR',
  CART = 'CART',
  LEGAL_WARNING = 'LEGAL_WARNING',
  CONDITIONS_OF_SALE = 'CONDITIONS_OF_SALE',
  LINKING_AGREEMENT = 'LINKING_AGREEMENT',
  TERMS_CONDITIONS_OF_ORDER = 'TERMS_CONDITIONS_OF_ORDER',
  TERMS_CONDITIONS_OF_USE = 'TERMS_CONDITIONS_OF_USE',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  UPLOAD_FILES = 'UPLOAD_FILES',
  MY_ACCOUNT = 'MY_ACCOUNT',
  MANAGE_CREDENTIALS = 'MANAGE_CREDENTIALS',
  PROOF_ORDER = 'PROOF_ORDER',
  CUSTOMER_REGISTERED = 'CUSTOMER_REGISTERED',
  MY_ORDERS = 'MY_ORDERS',
  MY_INVOICES = 'MY_INVOICES',
  ARTWORK_SERVICES_REVIEW_INFO = 'ARTWORK_SERVICES_REVIEW_INFO',
  ERROR_PAGE = 'ERROR_PAGE',
  SUSTAINABILITY = 'SUSTAINABILITY',
  ORDER_ARTWORK_SERVICE = 'ORDER_ARTWORK_SERVICE',
  SAMPLE_SEARCH = 'SAMPLE_SEARCH',
  LABEL_LIBRARY = 'LABEL_LIBRARY',
  CALCULATOR_HELP = 'CALCULATOR_HELP',
  PERSONAL_INFOS = 'PERSONAL_INFOS',
  NEWSLETTER = 'NEWSLETTER',
  HEADER = 'HEADER',
  FOOTER = 'FOOTER',
  THANK_YOU = 'THANK_YOU',
  THANK_YOU_ORDER = 'THANK_YOU_ORDER',
  REQUEST_THANK_YOU = 'REQUEST_THANK_YOU',
  SURVEY_THANK_YOU = 'SURVEY_THANK_YOU',
  BLOGS_LANDING_PAGE = 'BLOGS_LANDING_PAGE',
  BLOGS = 'BLOGS',
  CUSTOM_PAGES = 'CUSTOM_PAGES',
  LABEL_LIBRARY_MY_ORDER_FILES = 'LABEL_LIBRARY_MY_ORDER_FILES',
  REORDER = 'REORDER',
  CUSTOM_FILES = 'CUSTOM_FILES',
  SUCCESS_STORIES = 'SUCCESS_STORIES',
  PRINT_FILE_ERRORS = 'PRINT_FILE_ERRORS',
  TUTORIAL = 'TUTORIAL',
  PRINT_FILE_ERRORS_FULL = 'PRINT_FILE_ERRORS_FULL',
  TUTORIAL_CMS = 'TUTORIAL_CMS'
}
